/**
 * Authentication Service
 *
 * This service contains general operations for the DTU Authentication resource
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuth2TokenResponse } from '@dtu/types-v2';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Class representing the Authentication API V2 Service
 */
@Injectable()
export class AuthApiV2Service {
  /**
   * Auth API Service
   * @param http - HTTP Client
   */
  constructor(private readonly http: HttpClient) {}

  /**
   * Handle user authorize
   */
  async authorize(code: string, state: string, verifier: string): Promise<OAuth2TokenResponse> {
    return lastValueFrom(this.http.post<OAuth2TokenResponse>(`${environment.apiV2}/oauth/authorize`, { code, state, verifier }));
  }
}
